import * as React from "react";
import {cs} from "../../../../../../react/chain-services";
import "./data-table-d.scss";
import {cx} from "emotion";
import {sum} from "../../../../../../utils/collections";
import {chain} from "../../../../../../utils/fs";
import {keyed} from "../../../../../../react/keyed";
import {InformationBadge} from "../../information-badge/information-badge";

export const DataTableD = ({rows, className=undefined, darkRows="odd", columns, getFooter=undefined, getExtraRows=undefined, emptyAction=undefined}) => cs(
    ({}) => (
        <table className={cx("data-table-d-6i8", className)} cellSpacing={0} cellPadding={0}>
            <colgroup>
                {columns.map((col, i) => (
                    <col
                        key={i}
                        // width={col.width}
                        style={{width: col.width}}
                    />
                ))}
            </colgroup>
            <thead>
            <tr>
                {columns.map((col, i) => (
                    <th
                        className={cx(
                            col.className,
                            {
                                sortable: col.sorting,
                                sortingActive: col.sorting?.direction,
                            },
                            col.align,
                        )}
                        key={i}
                        onClick={col.sorting?.toggle}
                        {...col.domAttrs}
                    >
                        {col.render ? (
                            col.render()
                        ) : (
                            col.label
                        )}

                        {col.sorting && (
                            <i className={col.sorting.direction === "asc" ? (
                                    "fa fa-caret-up"
                                ) : (
                                    "fa fa-caret-down"
                                )}
                                xd-qa-type="icon"
                                xd-qa-name={[col.domAttrs?.["xd-qa-name"], "Sort Caret"].filter(v=>v).join(" ")}
                            />
                        )}

                        {col.subTitle && (
                            <div className="sub-title" xd-qa-type="label" xd-qa-name={[col.domAttrs?.["xd-qa-name"], "Subtitle"].filter(v=>v).join(" ")}>
                                {col.subTitle}
                            </div>
                        )}

                        {col.toolTip && (
                            <div className="tool-tip" xd-qa-type="label" xd-qa-name={[col.domAttrs?.["xd-qa-name"], "Tooltip"].filter(v=>v).join(" ")}>
                                {InformationBadge({
                                    getTooltip: () => col.toolTip,
                                })}
                            </div>
                        )}
                    </th>
                ))}
            </tr>
            </thead>
            <tbody>

            {rows?.length ? <>
                {rows.map((row, i) => cs(
                    keyed(row.key ?? i),
                    ({}, next) => <>
                        {next()}
                        {row.expansion && row.expansion.render({colCount: columns.length})}
                    </>,
                    () => (
                        <tr
                            className={cx("data-row", {
                                darkBackground: darkRows && (i % 2 === (darkRows === "odd" ? 0 : 1)),
                            }, row.className)}
                            xd-qa-type="card"
                            xd-qa-name={row.xdQaName}
                            {...row.domAttrs ?? {}}
                        >
                            {row.columns.map((col, ci) => (
                                <td
                                    className={cx(
                                        columns[ci].className,
                                        columns[ci].align,
                                    )}
                                    key={ci}
                                    {...col.domAttrs}
                                >
                                    {col.render()}
                                </td>
                            ))}
                        </tr>
                    )
                ))}

                {getExtraRows?.({colCount: columns.length})?.map((extraRow, i) => (
                    <tr
                        className={cx(extraRow.className, {
                            darkBackground: darkRows && (extraRow.color ? extraRow.color === "dark" : ((rows?.length??0) + i) % 2 === (darkRows === "odd" ? 0 : 1)),
                        })}
                        key={extraRow.key ?? i}
                    >
                        {extraRow.columns.map((col, i) => (
                            <td key={i} className={col.className} colSpan={col.colSpan} ref={col.ref}>
                                {col.render?.()}
                            </td>
                        ))}

                        {chain(
                            columns.length - sum(extraRow.columns, (c) => c.colSpan??1),
                            (remainingCol) => !!remainingCol && (
                                <td colSpan={remainingCol}>&nbsp;</td>
                            ),
                        )}
                    </tr>
                ))}
            </> : (
                <tr className={cx("no-data", {disabled: !emptyAction?.onClick})}>
                    <td colSpan={columns.length} xd-qa-type="label" xd-qa-name={emptyAction?.label ?? "No data"}>
                        {emptyAction?.onClick ? (
                            <a onClick={emptyAction.onClick}>{emptyAction.label}</a>
                        ) : (
                            emptyAction?.label ?? "No data"
                        )}
                    </td>
                </tr>
            )}
            </tbody>

            {rows?.length > 0 && chain(
                getFooter?.({colCount: columns.length}),
                (footer) => footer && (
                    <tfoot>
                    <tr>

                        {footer.columns.map((col, i) => (
                            <td key={i} className={col.className} colSpan={col.colSpan} {...col.domAttrs}>
                                {col.render?.()}
                            </td>
                        ))}

                        {chain(
                            columns.length - sum(footer.columns, (c) => c.colSpan??1),
                            (remainingCol) => !!remainingCol && (
                                <td colSpan={remainingCol}>&nbsp;</td>
                            ),
                        )}
                    </tr>
                    </tfoot>
                ),
            )}
        </table>
    ),
);
